<template>
  <div id="add_filters" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Filter Percakapan</h5>
          <button
            @click="clearFilter(true)"
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <!-- {{tagsSelected}} -->
          <!-- {{this.filterRoomAdvance.tags_id}} -->
          <div class="col-sm-12 col-md-12">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>
                    <b>Label</b>
                  </label>
                  <div v-show="filterRoomAdvance.untag==false">
                    <multiselect
                      v-model="tagsSelected"
                      id="ajax"
                      label="name"
                      track-by="id"
                      placeholder="Pilih label..."
                      :multiple="true"
                      :custom-label="tagsCustomLabel"
                      :options="tagsOptions"
                      :searchable="true"
                      :loading="isLoading"
                      :internal-search="false"
                      :close-on-select="false"
                      :options-limit="300"
                      :limit="0"
                      :limit-text="tagsLimitText"
                      :max-height="600"
                      :show-no-results="true"
                      @search-change="tagsAsyncFind"
                      @select="tagsDispatchSelectOption"
                      @remove="tagsRemove"
                    >
                      <template slot="tag" slot-scope="{ option, remove }">
                        <span class="custom__tag">
                          <span>{{ option.name }}</span>
                          <span class="custom__remove" @click="remove(option)">❌</span>
                        </span>
                      </template>
                      <template slot="clear" slot-scope="props">
                        <div
                          class="multiselect__clear"
                          v-if="tagsSelected.length"
                          @mousedown.prevent.stop="clearAll(props.search)"
                        ></div>
                      </template>
                      <span slot="noResult">Label tidak ditemukan.</span>
                    </multiselect>
                  </div>
                  <div class="text-wrap" v-show="filterRoomAdvance.untag==false">
                    <template v-for="(row,idx) in tagsSelected">
                      <a style="margin-left:5px;" href="#" :key="idx">
                        <span class="badge bg-inverse-default">{{row.name}}</span>
                      </a>
                    </template>
                  </div>
                  <div class="text-wrap">
                    <input
                      v-model="filterRoomAdvance.untag"
                      :value="true"
                      type="checkbox"
                      id="untag"
                    />
                    <label for="untag">
                      <b>Hapus Label</b>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="submit-section">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <center>
                    <button
                      @click="clearFilter(true)"
                      data-dismiss="modal"
                      class="btn btn-md btn-danger"
                      type="button"
                    >
                      <i class="fa fa-default"></i> Bersihkan
                    </button>

                    <button
                      @click="submitFilter(true)"
                      class="btn btn-md btn-primary"
                      type="button"
                      :style="'margin-left:10px;'"
                      data-dismiss="modal"
                    >
                      <i class="fa fa-submit"></i> Terapkan
                    </button>
                  </center>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";
import { mapGetters } from "vuex";

import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");

export default {
  components: {
    Skeleton,
    Multiselect
  },
  data() {
    return {
      filterRoomAdvance: {
        untag: false,
        tags_id: []
      },
      tagsSelected: [],
      tagsOptions: [],
      tagsListParam: {
        name: "",
        page: 0,
        perPage: 20
      },
      isLoading: false
    };
  },
  watch: {
    isShowFilter: {
      handler: function(val, oldVal) {
        if (val != oldVal && val == true) {
          this.tagsAsyncFind("");
        } else if (val != oldVal && val == false) {
          this.submitFilter(false);
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(["agentSession"]),
    isShowFilter() {
      return this.$store.state.omniroom.isShowFilter;
    }
  },
  methods: {
    clearFilter(status) {
      this.$store.dispatch("omniroom/setIsFilterAdvanceClear", status);
      if (status == true) {
        this.tagsSelected = [];
        this.filterRoomAdvance.tags_id = [];
        this.filterRoomAdvance.untag = false;
        this.filterRoomAdvance.tags_filter = false;
        let param = {
          tags_filter: false,
          untag: false,
          tags_id: []
        };
        this.$store.dispatch("omniroom/setFilterRoomAdvance", param);
      }
    },
    submitFilter(status) {
      this.$store.dispatch("omniroom/setIsFilterAdvanceActive", status);
      if (status == true) {
        let param = {
          tags_filter: true,
          untag: this.filterRoomAdvance.untag,
          tags_id: this.filterRoomAdvance.tags_id
        };
        this.$store.dispatch("omniroom/setFilterRoomAdvance", param);
        this.clearFilter(false);
      }
      // else {
      //   // this.clearFilter(true);
      //   let param = {
      //     tags_filter: false,
      //     untag: false,
      //     tags_id: []
      //   };
      //   this.$store.dispatch("omniroom/setFilterRoomAdvance", param);
      // }
    },
    async tagsRemove(tag) {
      var index = this.filterRoomAdvance.tags_id.indexOf(tag.id);
      if (index > -1) {
        // only splice array when item is found
        this.filterRoomAdvance.tags_id.splice(index, 1); // 2nd parameter means remove one item only
      }
    },
    tagsDispatchSelectOption(optionSelected) {
      this.filterRoomAdvance.tags_id.push(optionSelected.id);
      // console.log("optionSelected:", optionSelected);
      // console.log(
      //   "this.filterRoomAdvance.tags_id:",
      //   this.filterRoomAdvance.tags_id
      // );
    },
    tagsLimitText(count) {
      return ` dan ${count} lainnya`;
    },
    tagsCustomLabel({ name }) {
      return `${name}`;
    },
    tagsAsyncFind(query) {
      this.isLoading = true;
      this.tagsListParam.name = query;
      this.$store
        .dispatch("crm/listTags", this.tagsListParam)
        .then(response => {
          this.isLoading = false;
          this.tagsOptions = response.data.data;
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
    },
    clearAll() {
      this.tagsSelected = [];
    }
  },
  async created() {},
  beforeDestroy() {},
  mounted() {},
  name: "filtersChat"
};
</script>


// WEBPACK FOOTER //
// src/views/omni/components/filters.vue